import { Box } from '@mui/material';
import React, { useState } from 'react';
import ProductLookup from './ProductLookup';

interface SearchItem {
  id: string;
  name: string;
  secondaryName?: string;
}

type SearchLookupProps = {
  items: SearchItem[];
  tooltip?: string;
};

const ExpandableSearchLookup: React.FC<SearchLookupProps> = ({ items, tooltip }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box
      id="search-box"
      sx={{
        margin: '0 auto',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
      }}
      onBlur={e => {
        const relatedTarget = e.relatedTarget as HTMLElement | null;
        if (relatedTarget && document.getElementById('search-box')?.contains(relatedTarget)) {
          return;
        }
        setExpanded(false);
      }}
      onClick={(e: any) => {
        if (!e.target.dataset.closable) setExpanded(true);
      }}
      tabIndex={-1} // To make the box focusable for handling blur
    >
      <ProductLookup items={items} expanded={expanded} maxListHeight="150px" onClose={() => setExpanded(false)} tooltip={tooltip} />
    </Box>
  );
};

export default ExpandableSearchLookup;
